export const TMBDAPIKEY="c137839232b492729d1a72c0821edfc9";
export const TMDB_POSTER_BASE = 'https://image.tmdb.org/t/p/original';
export const TMDB_BACKDROP_PATH = 'https://image.tmdb.org/t/p/w1400_and_h450_face/';
export const TMDB_POSTER_PATH = 'https://image.tmdb.org/t/p/w185_and_h278_face/';